module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5ebcdae84c8e628c0cdc4c7dc9ca7326.png";